import { convertToHex } from './color-convert';

export const darkRed = getComputedStyle(document.documentElement).getPropertyValue('--error');

export const lightestAccent = convertToHex(
  getComputedStyle(document.documentElement).getPropertyValue('--accent200')
);

export const accent = convertToHex(
  getComputedStyle(document.documentElement).getPropertyValue('--accent')
);

export const darkAccent = convertToHex(
  getComputedStyle(document.documentElement).getPropertyValue('--accent600')
);

export const lightAccent = convertToHex(
  getComputedStyle(document.documentElement).getPropertyValue('--accent400')
);

export const grayMedium = '#757575';

export const grayDarkest = 'var(--grayDarkest)';
